// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const bg: KnowledgePagesCopy = {
  knowledgePage: 'Страница със знания',
  knowledgePages: 'Страници със знания',
  featureOffTitle: 'Страниците със знания не са включени в това работно пространство.',
  featureOffBody: 'Контекстът и източниците на компанията все още са в Знания.',
  loadingPage: 'Зареждане на страницата…',
  loadingSuggestion: 'Зареждане на предложението…',
  cancel: 'Отказ',
  tryAgain: 'Опитайте отново',
  everyoneIn: 'Всички в {company}',
  yourCompany: 'вашата компания',
  revision: 'Редакция {n}',
  openRevision: 'Отваряне на редакция {n}',
  pageCount: 'one:страница|other:страници',
  topicCount: 'one:тема|other:теми',
  sectionCount: 'one:раздел|other:раздела',
  lineCount: 'one:ред|other:реда',
  documentCount: 'one:документ|other:документа',
  changeCount: 'one:промяна|other:промени',
  newPageCount: 'one:нова страница|other:нови страници',
  changedPageCount: 'one:променена страница|other:променени страници',
  otherSectionCount: 'one:друг раздел|other:други раздела',
  characterCount: 'one:знак|other:знака',
  diffStats: 'Променени: {sections} · добавени: {added} · премахнати: {removed}',
  diffMatchesBase: 'Предложеният текст съвпада с базовата редакция.',
  diffIntroduction: 'Въведение',
  diffOtherUnchanged: 'Без промяна: {sections}.',
  timeJustNow: 'току-що',
  originImportedFrom: 'Импортирано от {path}',
  originImportedFromCommit: 'Импортирано от {path} @ {commit}',
  authorityApprovedInPoneva: 'Одобрено в Poneva',
  authorityImported: 'Импортирано',
  authorityInRepository: '{canonicality} в хранилището',
  authorityVerified: 'проверено на {date}',
  authorRepositoryImport: 'Импорт от хранилище',
  authorSuggestedInChat: 'Предложено в чата',
  authorSuggestedInChatWith: 'Предложено в чата с {name}',
  authorSuggestedBy: 'Предложено от {name}',
  authorSuggestedByApp: 'Предложено от свързано приложение',
  authorSuggestedByColleague: 'Предложено от колега',
  authorSuggestedByYou: 'Предложено от вас',
  authorSuggestedOnBehalf: 'Предложено от {app} от името на {name}',
  authorSuggestedByAppOnBehalf: 'Предложено от свързано приложение от името на {name}',
  authorSuggestedAndApproved: 'Предложено и одобрено от {name}',
  approverApprovedBy: 'одобрено от {name}',
  approverAppliedBy: 'приложено от {name}',
  kindCreatePage: 'Нова страница',
  kindUpdatePage: 'Предложена промяна',
  kindArchivePage: 'Архивиране',
  statusConflict: 'Конфликт · страницата е променена',
  statusPending: 'Чака преглед',
  statusApproved: 'Одобрено',
  statusRejected: 'Отклонено',
  statusWithdrawn: 'Оттеглено',
  statusSuperseded: 'Заменено',
  errRevisionConflict: 'Тази страница беше променена, докато я преглеждахте.',
  errProposalChanged:
    'Това предложение беше променено, докато го преглеждахте. Прегледайте най-новата версия, преди да решите.',
  errPublishRequired:
    'Само хора с права за публикуване в компанията могат да одобряват промени в знанията или да импортират страници.',
  errProposalLimit:
    'Във вашата компания вече има 200 предложения, които чакат преглед. Прегледайте някои от тях, преди да предлагате още.',
  errAuthorLimit:
    'Вече имате 50 предложения, които чакат преглед. Изчакайте решение по някои от тях или оттеглете някои, преди да предлагате още.',
  errImportProposalLimit:
    'Този импорт би добавил повече променени страници за преглед, отколкото побира опашката за преглед на компанията ви (най-много 200). Вземете решение по някои предложения в раздела За преглед и приложете отново.',
  errImportChanged:
    'Това не е импортът, който сте прегледали. Отворете го отново и го прегледайте, преди да го приложите.',
  errImportItemNotFound: 'Този документ вече не е част от импорта.',
  errIdempotencyConflict:
    'Това предложение вече е изпратено с различно съдържание. Презаредете и опитайте отново.',
  errImportHashMismatch:
    'Файл в тази моментна снимка не съвпада със записаната си контролна сума. Създайте моментната снимка отново и опитайте пак.',
  errImportAlreadyApplied: 'Този импорт вече е приложен.',
  errImportDiscarded: 'Този импорт беше отхвърлен. Изберете файла с моментната снимка отново.',
  errImportDuplicateItem:
    'Тази моментна снимка съдържа един и същ документ два пъти. Създайте моментната снимка отново.',
  errInvalidImport:
    'Poneva не можа да приеме тази моментна снимка. Създайте я отново със скрипта за моментни снимки и опитайте пак.',
  errInvalidInput: 'Poneva не можа да приеме тези данни. Проверете полетата и опитайте отново.',
  errImportLimit:
    'Има твърде много подготвени, но неприложени импорти. Приложете или отхвърлете някои, преди да подготвите нов.',
  errPageTooLarge: 'Страница е по-голяма от 256 KB. Разделете я на по-малки страници.',
  errTooManySections: 'Страница има повече от 2000 заглавия. Разделете я на по-малки страници.',
  errPageLimit: 'Компанията ви достигна ограничението от 2000 страници със знания.',
  errCollectionLimit: 'Компанията ви достигна ограничението от 100 теми.',
  errProposalNotPending: 'По това предложение вече има решение. Показаният статус е актуален.',
  errRequesterRemoved:
    'Човекът, който е предложил това, вече не е в тази компания, затова то не може да бъде одобрено.',
  errRevisionAlreadyCurrent: 'Тази редакция вече е текущата.',
  errPageArchived:
    'Тази страница беше архивирана, докато я преглеждахте. Прегледайте предложението отново, преди да решите.',
  errAlreadyArchived: 'Тази страница вече е архивирана.',
  errProposalForbidden: 'Само човекът, който е предложил това, може да го оттегли.',
  errUnavailable: 'Страниците със знания в момента не са налични.',
  errTimeout: 'Poneva отговаряше твърде дълго.',
  errItemTooLarge: '{path} е по-голям от 256 KB. Разделете го на по-малки страници.',
  errItemTooManySections: '{path} има повече от 2000 заглавия. Разделете го на по-малки страници.',
  errItemHashMismatch:
    '{path} не съвпада със записаната си контролна сума. Създайте моментната снимка отново и опитайте пак.',
  errNoLongerAvailable: 'Този елемент вече не е достъпен за вас.',
  errTooLargeToSend: 'Този файл е твърде голям, за да бъде изпратен.',
  cardChecking: 'Проверка на статуса…',
  cardNotAvailable: 'Не е налично',
  cardStatusUnavailable: 'Статусът не е наличен',
  cardUnshowable: 'Тази предложена промяна в знанията не можа да бъде показана.',
  cardEyebrow: 'Предложена промяна в знанията',
  cardLabel: 'Предложена промяна в знанията · {title}',
  cardMissing: 'Това предложение вече не е достъпно за вас.',
  cardUnknown:
    'Не успяхме да проверим докъде е стигнало това предложение. Отворете прегледа, за да видите статуса му.',
  cardCheckAgain: 'Нова проверка',
  cardReview: 'Преглед на промяната',
  statusLineApproved: 'Одобрено разбиране',
  readyCount: 'one:готов за търсене|other:готови за търсене',
  preparingCount: 'one:в подготовка|other:в подготовка',
  attentionCount: 'one:изисква внимание|other:изискват внимание',
  topicsExplore: 'Разгледайте тема',
  topicsAllPages: 'Всички страници',
  topicsOpenPages: 'Отваряне на Страници',
  topicsEmpty:
    'Все още няма одобрени страници. Страниците съдържат подробно описано разбиране на компанията с пълната история на редакциите.',
  reviewsTitle: 'Предложени промени в страници',
  reviewsTitleMine: 'Вашите предложени промени в страници',
  reviewsIntro:
    'Всяко предложение е пълна кандидат-редакция с причина и доказателства. Нищо не се променя, докато не одобрите точно тази редакция.',
  reviewsIntroMine:
    'Предложенията ви чакат тук, докато човек с права за публикуване в компанията не ги прегледа. Дотогава страниците остават непроменени.',
  loadPagesFailed: 'Не успяхме да заредим страниците със знания.',
  loadProposalsFailed: 'Не успяхме да заредим предложените промени в страници.',
  loadMoreFailed: 'Не успяхме да заредим още страници.',
  otherPages: 'Други страници',
  loadTopicFailed: 'Не успяхме да заредим тази тема.',
  revisionShort: 'р{n}',
  updatedOn: 'Обновено на {date}',
  emptyTitle: 'Все още няма страници със знания.',
  emptyBody:
    'Страниците съдържат одобреното, подробно описано разбиране на вашата компания – посока, решения и начини на работа – като всяка редакция се пази. Импортирайте от моментна снимка на хранилище или започнете страница в чата; човек с права за публикуване одобрява всяка страница, преди тя да стане знание на компанията.',
  importFromSnapshot: 'Импортиране от моментна снимка на хранилище',
  startInChat: 'Започване на страница в чата',
  startInChatPrompt:
    'Помогни ми да започна страница със знания за нашата компания. Попитай ме какво трябва да обхваща и не измисляй съдържание. Тя остава предложение, докато човек с права за публикуване в компанията не я одобри.',
  loadingPages: 'Зареждане на страниците със знания…',
  filterLabel: 'Филтриране на страниците по заглавие',
  filterPlaceholder: 'Филтриране на страниците',
  importButton: 'Импортиране',
  showingTopic: 'Показване на {topic}',
  showAllTopics: 'Показване на всички теми',
  loadingTopic: 'Зареждане на темата…',
  noMatch: 'Няма страници, които съответстват на „{filter}“.',
  topicNoPages: 'В тази тема все още няма одобрени страници.',
  loading: 'Зареждане…',
  loadMore: 'Зареждане на още страници',
  metaApproved: 'одобрено на {date}',
  metaRepositoryAuthoritative: 'хранилището остава водещ източник',
  loadPageFailed: 'Не успяхме да заредим тази страница.',
  loadHistoryFailed: 'Не успяхме да заредим историята на редакциите.',
  outlineLabel: 'Раздели на страницата',
  outlineToggle: 'На тази страница',
  loadingHistory: 'Зареждане на историята на редакциите…',
  historyLabel: 'История на редакциите',
  historyIntro:
    'Всяка одобрена редакция се пази. Възстановяването на по-ранна редакция създава предложение за преглед; то никога не изтрива по-късните редакции.',
  historyCurrent: 'Текуща',
  historyViewing: 'Преглежда се',
  historyView: 'Преглед',
  historyViewAria: 'Преглед на редакция {n}',
  restoreAria: 'Възстановяване като предложение: редакция {n}',
  restoreCreating: 'Създаване на предложение…',
  restore: 'Възстановяване като предложение',
  restoreUnconfirmed:
    'Не успяхме да потвърдим, че предложението е създадено. Проверете раздела За преглед, преди да опитате отново.',
  editTooLarge:
    'Тази страница е по-голяма от 256 KB. Разделете я на по-малки страници, преди да я предложите.',
  editConflict:
    'Тази страница беше променена, докато я редактирахте. Копирайте текста си, отворете най-новата редакция и предложете промяната отново.',
  editUnconfirmed:
    'Не успяхме да потвърдим, че предложението ви е изпратено. Проверете раздела За преглед, преди да го изпратите отново.',
  editHeading: 'Предлагане на промяна',
  editIntro:
    'Редактирате редакция {n}. Човек с права за публикуване в компанията преглежда точната промяна, преди тя да стане редакция {next}; дотогава страницата остава непроменена.',
  editOutdated:
    'Докато редактирахте, беше одобрена по-нова редакция. Копирайте текста си и започнете отново от най-новата редакция, за да не се загуби нищо от промените в нея.',
  editContentLabel: 'Съдържание на страницата (Markdown)',
  editReasonLabel: 'Защо е тази промяна?',
  editReasonPlaceholder: 'Какво се промени и откъде идва.',
  editSending: 'Изпращане…',
  editSend: 'Изпращане за преглед',
  editDiscardConfirm: 'Да се отхвърли ли тази редакция? Нищо от промените ви не е изпратено.',
  editNoChanges: 'Все още няма промени.',
  editNeedsContent: 'Страницата трябва да има съдържание.',
  exportFailed: 'Не успяхме да експортираме тази страница. Опитайте отново.',
  askPagePrompt: 'Въпрос за страницата със знания „{title}“ (редакция {n}, {link}):',
  askPageSectionPrompt:
    'Въпрос за страницата със знания „{title}“ § {section} (редакция {n}, {link}):',
  pageMissingTitle: 'Тази страница не е налична.',
  pageMissingBody: 'Може да е архивирана или вече да нямате достъп до знанията на тази компания.',
  pageArchived: 'Архивирана',
  viewingRevisionCurrent: 'Преглеждате редакция {n}; текущата редакция е {current}.',
  viewingRevisionOld: 'Преглеждате редакция {n}. Тя не е текущата редакция.',
  openCurrent: 'Отваряне на текущата',
  archivedBanner:
    'Тази страница е архивирана. Тя вече не се използва в отговорите; историята ѝ се пази.',
  pageViewsLabel: 'Изгледи на страницата',
  tabRead: 'Четене',
  tabHistory: 'История',
  unknownSection: 'Свързаният раздел не е част от тази редакция. Показва се цялата страница.',
  askAboutPage: 'Въпрос за тази страница',
  exporting: 'Експортиране…',
  exportMarkdown: 'Експортиране в Markdown',
  loadSuggestionFailed: 'Не успяхме да заредим това предложение.',
  evidenceSource: 'Източник',
  evidenceFact: 'Контекст на компанията',
  evidenceResult: 'Запазена работа',
  evidenceUrl: 'Уеб страница',
  evidenceDecision: 'Решение',
  evidenceReference: 'Препратка',
  evidenceOpenPage: 'Отваряне на страницата със знания',
  evidenceOpenSource: 'Отваряне на източника',
  evidenceOpenFact: 'Отваряне на контекста на компанията',
  evidenceOpenResult: 'Отваряне на запазената работа',
  evidenceOpenUrl: 'Отваряне на уеб страницата',
  evidenceOpenDecision: 'Отваряне на решението',
  evidenceOpenReference: 'Отваряне на препратката',
  evidenceDecisionNote: 'Записано решение. В Poneva няма какво да се отвори.',
  evidenceFactGone: 'Този контекст на компанията вече не е запазен.',
  evidencePageNoRevision: 'Тази страница няма одобрена редакция, която да се отвори.',
  evidencePrivateExcerpt: 'Лично доказателство – споделен е само откъсът по-горе.',
  evidencePrivate: 'Лично доказателство – съдържанието му не е споделено с вас.',
  evidenceHeading: 'Доказателства',
  evidenceNone: 'Не са приложени доказателства. Преценете причината по-горе самостоятелно.',
  changeAdded: 'Добавено',
  changeRemoved: 'Премахнато',
  changeChanged: 'Променено',
  changeUnchanged: 'Без промяна',
  moreLineCount: 'one:допълнителен ред|other:допълнителни реда',
  moreUnchangedLineCount: 'one:допълнителен непроменен ред|other:допълнителни непроменени реда',
  unchangedLineCount: 'one:непроменен ред|other:непроменени реда',
  skipAdded: '{lines} – вижте пълната редакция',
  skipRemoved: 'Премахнати: {lines}',
  cutUnchanged: 'Не се показват: {lines}',
  cutChanged: 'Не се показват: {lines}, {changes}. Проверете ги в пълната редакция.',
  cutAddedRemoved: 'добавени {added} и премахнати {removed}',
  cutAdded: 'добавени {added}',
  cutRemoved: 'премахнати {removed}',
  lineAddedSr: 'Добавено:',
  lineRemovedSr: 'Премахнато:',
  noLinesAdded: 'Нов раздел. Текстът му е в пълната редакция по-долу.',
  noLinesRemoved: 'Този раздел ще бъде премахнат от страницата.',
  noLinesChanged: 'Този раздел се променя. Текстът му е в пълната редакция по-долу.',
  diffHeading: 'Промени',
  outcomeArchived: 'Архивирано.',
  outcomeArchivedBody:
    '„{title}“ вече не се използва в отговорите и е премахната от списъка със страници. Редакциите ѝ, това предложение и решението остават в историята на страницата.',
  openArchivedPage: 'Отваряне на архивираната страница',
  outcomeApproved: 'Одобрено.',
  outcomeApprovedRevision: 'Редакция {n} вече е одобрената версия на „{title}“.',
  outcomeApprovedPlain: 'Това предложение беше одобрено.',
  outcomeRestored: 'Страницата е отново в списъка със страници и пак се използва в отговорите.',
  outcomeKept:
    'Предложението, решението и всяка по-ранна редакция остават в историята на страницата.',
  openPage: 'Отваряне на страницата',
  outcomeDismissed: 'Отклонено.',
  outcomeWithdrawn: 'Оттеглено.',
  outcomeSuperseded: 'Заменено.',
  outcomeSupersededBody:
    'По-нова редакция, предложение или импорт от хранилище направи това предложение остаряло. Само по себе си то не промени нищо.',
  outcomeUnchanged: 'Страницата остава непроменена.',
  approveNewPage: 'Одобряване на новата страница',
  approveArchive: 'Одобряване на архивирането',
  approveRestoreRevision: 'Възстановяване и одобряване на редакция {n}',
  approveRevision: 'Одобряване на редакция {n}',
  approveArchiveNote: 'С одобряването тази страница се архивира за всички в {company}.',
  approvePublishNote: 'С одобряването тази редакция се публикува за всички в {company}.',
  approvePublishEvidenceNote:
    'С одобряването тази редакция и показаните по-горе откъси от доказателства се публикуват за всички в {company}.',
  archivedTitle: 'Тази страница е архивирана.',
  alreadyArchivedBody:
    'Одобряването няма да промени нищо, затова това предложение може само да бъде отклонено.',
  archivedRestoreBody:
    'Одобряването я възстановява: страницата се връща в списъка със страници, в търсенето и в отговорите с тази редакция.',
  staleRevisionAction: 'Сравняване с най-новата версия',
  staleProposalTitle: 'Това предложение беше променено, докато го преглеждахте.',
  staleProposalAction: 'Преглед на най-новата версия',
  staleArchivedTitle:
    'Тази страница беше архивирана, докато я преглеждахте. Одобряването на това предложение ще я върне.',
  staleArchivedAction: 'Нов преглед',
  suggestionMissingTitle: 'Това предложение не е налично.',
  suggestionMissingBody:
    'Може да е оттеглено или да принадлежи на друг човек и да не е изпратено за преглед от компанията.',
  decideUnconfirmed:
    'Не успяхме да потвърдим решението ви. Показаният статус е най-новият от Poneva; проверете го, преди да опитате отново.',
  decideFailed: 'Не успяхме да запазим решението ви.',
  discussPrompt: 'Помогни ми да подобря предложената промяна в знанията за „{title}“ ({link}).',
  conflictBody:
    'Това предложение е написано спрямо редакция {base}; текущата редакция е {current}. Одобряването му би презаписало тази промяна, затова не може да бъде одобрено в този вид.',
  conflictBodyPlain:
    'Това предложение е написано спрямо по-ранна редакция, затова не може да бъде одобрено в този вид.',
  openLatest: 'Отваряне на най-новата версия',
  reworkInChat: 'Преработване в чата',
  factReason: 'Причина',
  factNoReason: 'Не е посочена причина.',
  factAudience: 'Аудитория',
  factRevision: 'Редакция',
  revisionNew: 'Нова страница, редакция 1',
  revisionArchiveAfter: 'Архивиране след редакция {n}',
  revisionWrittenAgainst: 'Написано спрямо редакция {base}; текущата редакция е {current}',
  revisionCurrentToProposed: 'Текуща редакция {base} → предложена редакция {next}',
  revisionProposed: 'Предложена редакция {next}',
  proposedPage: 'Предложена страница',
  archivingHeading: 'Какво прави архивирането',
  archivingBody:
    'Страницата престава да се използва в отговорите и се премахва от списъка със страници. Редакциите ѝ и това решение се пазят.',
  noComparison: 'За това предложение няма сравнение по раздели.',
  showComplete: 'Показване на пълната редакция',
  approving: 'Одобряване…',
  dismissing: 'Отклоняване…',
  dismiss: 'Отклоняване',
  withdrawing: 'Оттегляне…',
  withdraw: 'Оттегляне',
  editInChat: 'Редактиране в чата',
  waitingForPublisher: 'Чака преглед от човек с права за публикуване в компанията.',
  snapshotTooLarge: 'Тази моментна снимка е по-голяма от 8 MB. Създайте я с по-малко документи.',
  snapshotNotSnapshot:
    'Този файл не е моментна снимка на знания. Изберете JSON файла, създаден от скрипта за моментни снимки.',
  snapshotEmpty: 'Тази моментна снимка не съдържа документи.',
  readDocumentFailed: 'Не успяхме да прочетем този документ. Опитайте отново.',
  readingDocument: 'Четене на документа…',
  hideText: 'Скриване на текста',
  readText: 'Четене на текста',
  textOf: 'Текст на „{title}“',
  gitSnapshot: 'Git моментна снимка {commit}',
  repositorySnapshot: 'Моментна снимка на хранилище',
  importNewHeading: '{pages} · одобряване при прилагане',
  importNewNote:
    'Всяка се публикува като одобрена страница за всички в {company}, без допълнителен преглед. Прочетете всяка, преди да приложите.',
  importChangedHeading: '{pages} · изпращане за преглед',
  importChangedNote:
    'Всяка става предложена промяна. Страницата ѝ се променя едва когато човек с права за публикуване я одобри в раздела За преглед, където се вижда какво е променено.',
  unchangedDocumentCount: 'one:непроменен документ|other:непроменени документа',
  unchangedNote: 'Те вече съвпадат с одобрените си страници. За тях не се записва нищо.',
  stagedHeading: 'Подготвени, но неприложени',
  excludedSummary: 'Изключени от тази моментна снимка: {documents}',
  countsLine: '{newPages} · {changedPages} за преглед · {unchanged} без промяна',
  importAlreadyDiscarded: 'Този импорт вече е отхвърлен.',
  confirmLabel: 'Потвърждаване на импорта',
  unchangedKeepCount:
    'one:непроменен документ запазва страницата си|other:непроменени документа запазват страниците си',
  confirmBody:
    'Да се приложи ли този импорт за всички в {company}? {newPages}: одобряване като редакция 1; {changedPages}: изчакване на преглед; {unchanged}. По-ранните предложения от импорт за тези страници се оттеглят.',
  applying: 'Прилагане…',
  applyImport: 'Прилагане на импорта',
  chooseAnother: 'Избор на друг файл',
  allCurrent: 'Всичко в тази моментна снимка вече е актуално.',
  importApplied: 'Импортът е приложен.',
  appliedSummary: 'Създадени: {pages} · чакат преглед: {changes} · без промяна: {unchanged}.',
  appliedIndexing:
    'Новите страници стават достъпни за търсене в чата след края на индексирането. Подготовката на източниците показва напредъка.',
  openPages: 'Отваряне на страниците',
  reviewChanges: 'Преглед на {changes}',
  checkIndexing: 'Проверка на индексирането',
  sendSnapshotFailed: 'Не успяхме да изпратим тази моментна снимка. Опитайте отново.',
  openStagedFailed: 'Не успяхме да отворим този подготвен импорт.',
  applyUnconfirmed:
    'Не успяхме да потвърдим дали импортът е приложен. Проверете раздела Страници, преди да опитате отново.',
  applyFailed: 'Не успяхме да приложим този импорт.',
  importHeading: 'Импортиране на страници от хранилището',
  backToPages: 'Обратно към страниците',
  importLead:
    'Създайте моментна снимка с {command} и изберете файла. Ще видите всеки документ и какво би променил, преди да се запази каквото и да е.',
  snapshotFileLabel: 'Файл с моментна снимка на знания',
  readingSnapshot: 'Четене на моментната снимка…',
  openingStaged: 'Отваряне на подготвения импорт…',
  chooseSnapshot: 'Избор на файл с моментна снимка',
  factOrigin: 'Произход',
  factContents: 'Съдържание',
  importOnlyListed: 'Импортират се само изброените тук документи.',
  importRepositoryAuthoritative:
    'Хранилището остава водещ източник; променените документи стават предложения за преглед.',
  overviewReviewChanges: 'Преглед на промените',
  overviewConnectAgents: 'Свързване на външни агенти',
  overviewEyebrow: 'Общо разбиране',
  overviewTitle: '{company} в контекст.',
  overviewLeadFallback:
    'Знанията на компанията ви започват с контекста, който споделяте. Изградете заедно разбиране за бизнеса си.',
  overviewBody:
    'Контекстът на компанията и изходните материали дават на Poneva отправна точка – не всичко, което може да се знае за {company}. Продължете да изграждате това разбиране, докато бизнесът ви се развива.',
  overviewAskPrompt: 'Какво знаеш за нашата компания и какво би било полезно да добавим?',
  overviewAsk: 'Въпрос за {company}',
  overviewAddSources: 'Добавяне на източници',
  contextEyebrow: 'Какво дава контекст на отговорите',
  contextTitle: 'Бизнесът зад въпроса.',
  contextBody:
    'Източниците от уебсайта обясняват публичната страна на бизнеса. Бележките на компанията добавят вашата терминология, приоритети и начин на работа.',
  contextPrompt:
    'Помогни ми да изясня приоритетите на компанията и предпочитанията ни за работа, които трябва да запомним.',
  contextAction: 'Изграждане на нашето разбиране',
  learnEyebrow: 'Място за учене',
  learnTitle: 'Започнете с това, което е важно сега.',
  learnBody:
    'Добавете изходни материали или изяснете как работи компанията ви. Poneva може да предлага трайни промени, които да прегледате.',
  learnPrompt:
    'Въз основа на сегашните знания за компанията ни каква важна информация липсва за работата, която искаме да вършим?',
  learnAction: 'Обсъждане на полезното',
  canvasEmptyTitle: 'Малко контекст стига далеч.',
  canvasEmptyBody:
    'Профилът на компанията ви е отправната точка. Добавете изходни материали и прегледани бележки, за да помогнете на Poneva да разбере работата ви.',
  pageEyebrow: 'Работно пространство на {company}',
  pageTitle: 'Знания на компанията',
  pageDescription: 'Източниците и разбирането, на които се основава работата на Poneva.',
  tabOverview: 'Общ преглед',
  tabPages: 'Страници',
  tabSources: 'Източници',
  tabReview: 'За преглед',
  proposalApproved: 'Одобрен контекст на компанията',
  proposalDismissed: 'Отклонено предложение',
  proposalRemoval: 'Предложено премахване',
  proposalCorrection: 'Предложена корекция',
  proposalContext: 'Предложен контекст на компанията',
  proposalCurrent: 'Текущо разбиране',
  proposalFactGone:
    'Запазеният факт вече не е наличен. Опреснете знанията за компанията, преди да прегледате това премахване.',
  proposalReviewFallback: 'Прегледайте предложения контекст на компанията.',
  proposalNotSaved: 'Все още не е запазено. Оригиналните източници остават непроменени.',
  proposalWaiting: 'Чака преглед · човек с права за публикуване решава във Входящи',
  proposalSaving: 'Запазване…',
  proposalApproveRemoval: 'Одобряване на премахването',
  proposalApproveClarification: 'Одобряване на уточнението',
  factLabel: 'Факт за компанията',
  factEyebrow: 'Факт · Всички в {company}',
  factSuggestCorrection: 'Предлагане на корекция',
  factAskPrompt:
    'Помогни ми да разбера или уточня този запазен контекст на компанията: „{content}“',
  factAsk: 'Въпрос за това',
  companyContextHeading: 'Контекст на компанията',
  companyContextPrompt:
    'Искам да уточня знанията за нашата компания. Помогни ми да прегледам какво знаем и да предложа промяна.',
  companyContextEmpty:
    'Все още няма одобрени бележки. Започнете разговор за компанията си или добавете изходни материали по-долу.',
  refineInChat: 'Доработване в чата',
  reviewPanelLabel: 'Промени в знанията за преглед',
  suggestedUpdatesHeading: 'Предложени промени',
  suggestedUpdatesIntro:
    'Предложения от вашите разговори. Вие решавате какво да стане част от трайните знания на компанията ви.',
  reviewEmptyTitle: 'Нищо не чака вашия преглед.',
  reviewEmptyBody:
    'Когато Poneva предложи промяна в знанията за компанията ви, ще я намерите тук. Трайните промени винаги изискват вашето одобрение.',
  reviewEmptyPrompt:
    'Помогни ми да прегледам знанията за нашата компания и предложи какво би било полезно да уточним след това.',
  inclusionPendingApproval: 'Промяната във включването в знанията е изпратена за одобрение.',
  sourcesFileIncluded: 'Файлът е включен в търсенето в знанията за текущата си аудитория.',
  sourcesAddFailed: 'Този източник не можа да бъде добавен.',
  sourcesHeading: 'Материалите зад отговорите.',
  sourcesIntro:
    'Poneva търси в целия изходен материал, не само в общия преглед. Пазете оригиналите, вижте кое е готово и изберете на какво да се основават отговорите ви.',
  addSourceHeading: 'Добавете материали от компанията си',
  addSourceIntro:
    'Качените източници остават лични във вашата Библиотека и се използват само за вашите отговори. Изберете Споделяне, когато сте готови да ги предоставите на колегите си.',
  uploadSource: 'Качване на източник',
  addSourcePrompt:
    'Помогни ми да добавя изявление на компанията като споделен вътрешен източник. Попитай ме какво искам да запиша и не измисляй съдържание. Трайните промени в разбирането за компанията все още изискват моето одобрение.',
  addThroughChat: 'Добавяне чрез чата',
  addingSource: 'Добавяне…',
  addToKnowledge: 'Добавяне към знанията',
  uploadFormats: 'TXT, Markdown, CSV и JSON · До 5 MB на файл',
  sourceExcluded: 'Изключен от отговорите',
  sourcePreparationFailed: 'Подготовката е неуспешна',
  sourcePreparing: 'Подготвя се за търсене',
  sourceWaiting: 'Чака подготовка',
  sourceReadinessUnknown: 'Няма данни за готовността',
  sourceRetryQueued: 'Подготовката е в опашката. Готовността ще се обнови, когато приключи.',
  sourceIncludedNotice: 'Източникът е включен. Poneva ще го подготви за търсене.',
  sourceExcludedNotice: 'Изключен от отговорите. Оригиналният източник се запазва.',
  sourceUpdateFailed: 'Този източник не можа да бъде обновен.',
  sourceOriginalMaterial: 'Оригинален изходен материал',
  sourceDiscuss: 'Обсъждане в чата',
  sourceDiscussPrompt: 'Помогни ми да разбера или уточня „{title}“.',
  sourceExclude: 'Изключване от отговорите',
  sourceInclude: 'Включване в отговорите',
  sourcesLoadFailed: 'Не успяхме да заредим източниците ви.',
  sourceLibraryLabel: 'Библиотека с източници на компанията',
  sourceListCaption: 'Оригинални източници · включени и изключени',
  sourceSearchLabel: 'Търсене в източниците на компанията',
  sourceSearchPlaceholder: 'Търсете в източниците си…',
  sourcesFinding: 'Търсене на източниците ви…',
  sourcePagesLabel: 'Страници с източници',
  sourceRange: '{from}–{to} от {count}',
  sourceCount: 'one:източник|other:източника',
  sourcePrevious: 'Предишна',
  sourceNext: 'Следваща',
  sourceNoMatchTitle: 'Няма съответстващи източници.',
  sourceNoMatchBody: 'Опитайте с друга фраза или име на източник.',
  sourceEmptyTitle: 'Дайте на въпросите си по-силна отправна точка.',
  sourceEmptyBody:
    'Добавете документи на компанията, продуктови данни или работни бележки. Poneva може да използва целия изходен материал в разговорите и в Skills.',
  indexCheckFailed: 'Не успяхме да проверим подготовката на източниците.',
  indexRetryQueued:
    'Неуспешните записи в знанията са добавени в опашката за подготовка. Изходните ви материали остават непроменени.',
  indexQueueFailed: 'Не успяхме да добавим подготовката в опашката. Опитайте отново.',
  indexPreparing: 'Подготвяне на нови знания за вашите разговори…',
  indexAttention: 'Част от знанията изискват внимание.',
  queuing: 'Добавяне в опашката…',
  retryPreparation: 'Повторна подготовка',
  sourceKindStatement: 'Изявление на компанията',
  sourceKindWebsite: 'Уебсайт',
  sourceKindDocument: 'Документ',
  factAnswers: 'one:отговор|other:отговора',
  factUsedThisWeek: 'Използван в {answers} тази седмица',
  factLastUsed: 'последно използван: {when}',
  factToday: 'днес',
  factYesterday: 'вчера',
  factImpact: 'Промяната засяга факт, използван в {answers} тази седмица.',
  factCorrectionAbout: 'За този факт за компанията: „{content}“ ({link})',
  factCorrectionOutdated: 'Това е остаряло:',
  sourceCanvasRecorded: 'Записан изходен материал',
  sourceCanvasNotIncluded:
    'Не е включен в знанията за компанията. Оригиналът се пази за справка и все още може да се използва в конкретен разговор.',
  sourceCanvasOpenOriginal: 'Отваряне на оригиналния източник',
  sourceCanvasUnavailable: 'Съдържанието на източника не е налично.',
  sourceCanvasDiscussPrompt: 'Помогни ми да разбера или уточня „{title}“.',
  sourceCanvasDiscuss: 'Обсъждане на този източник',
  sourceCanvasCorrectionNote:
    'Корекцията става предложен контекст на компанията. Записаният източник остава непроменен.',
  contextCanvasEyebrow: 'Наличен контекст на компанията',
  contextCanvasTitle: 'Знанията зад този разговор.',
  contextCanvasBody:
    'Одобрено разбиране и изходните материали, добавени от вашата компания. Налични в чата и в Skills.',
  contextCanvasOpen: 'Отваряне на Знания',
};

export default bg;
